import React from "react";

const CloseIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25367 12.0042C0.93501 12.0042 0.616352 11.8868 0.36478 11.6352C-0.121593 11.1488 -0.121593 10.3438 0.36478 9.85744L9.85744 0.36478C10.3438 -0.121593 11.1488 -0.121593 11.6352 0.36478C12.1216 0.851153 12.1216 1.65618 11.6352 2.14256L2.14256 11.6352C1.90776 11.8868 1.57233 12.0042 1.25367 12.0042Z"
        fill="#292D32"
      />
      <path
        d="M10.7463 12.0042C10.4277 12.0042 10.109 11.8868 9.85744 11.6352L0.36478 2.14256C-0.121593 1.65618 -0.121593 0.851153 0.36478 0.36478C0.851153 -0.121593 1.65618 -0.121593 2.14256 0.36478L11.6352 9.85744C12.1216 10.3438 12.1216 11.1488 11.6352 11.6352C11.3836 11.8868 11.065 12.0042 10.7463 12.0042Z"
        fill="#292D32"
      />
    </svg>
  );
};

export default CloseIcon;
